
export default { name: "simple-examination" };
